import { Resource as n, API as r } from "@coveo/platform-client";
const s = class s extends n {
  /**
   * Get the document permission model information for a security identity.
   *
   * @param {string} indexId The unique identifier of the target index.
   * @param {string} documentId The unique identifier of the item whose permissions to list.
   * @param {DocumentSecurityIdentityModel} the security identity for which we want the permissions from.
   *
   */
  getIdentityPermissions(o, i, t) {
    return this.api.post(
      `${s.baseUrl}/${o}/documents/${encodeURIComponent(
        encodeURIComponent(i)
      )}/permissions/identity`,
      t
    );
  }
};
s.baseUrl = `/rest/organizations/${r.orgPlaceholder}/indexes`;
let e = s;
export {
  e as DocumentIdentityResource
};
//# sourceMappingURL=DocumentIdentityResource.js.map
